
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/oersterk",
      function () {
        return require("private-next-pages/archive/oersterk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/oersterk"])
      });
    }
  